import {HProduceSuiteLogger} from '../../logger/HProduceSuiteLogger'

import {GenericErrorBoundary} from './GenericErrorBoundary'
import {RootErrorFallback} from './RootErrorFallback'

interface RootErrorBoundaryProps {
  children: React.ReactNode
}

export const RootErrorBoundary = ({children}: RootErrorBoundaryProps) => {
  return (
    <GenericErrorBoundary
      fallbackRender={() => <RootErrorFallback />}
      onError={(error, info) => {
        HProduceSuiteLogger.context('RootErrorBoundary', String(info.componentStack)).fatal(
          `${error.name}: ${error.message}`
        )
      }}
    >
      {children}
    </GenericErrorBoundary>
  )
}
